<template>
  <div class="card">
    <header class="header-card">
      <p>
        {{ $t('produitSalon.caracteristique.title') }}
      </p>
    </header>
    <div class="card-content">
      <div class="columns is-multiline is-vcentered">
        <div class="column is-2">
          <p class="has-text-default is-italic">
            {{ $t('detailProduitSalon.caracteristique.code') }}
          </p>
          <p class="has-text-weight-bold">{{ produit.reference }}</p>
        </div>
        <div class="column is-2">
          <p class="has-text-default is-italic">
            {{ $t('detailProduitSalon.caracteristique.libelle') }}
          </p>
          <p class="has-text-weight-bold">{{ produit.libelle }}</p>
        </div>
        <div class="column is-2" v-if="agencesSelectionnees.length > 1">
          <p class="has-text-default is-italic">
            {{ $t('detailProduitSalon.caracteristique.agence') }}
          </p>
          <p class="has-text-weight-bold">{{ getAgenceLibelle(produit.agenceId) }}</p>
        </div>
        <div class="column is-2">
          <p class="has-text-default is-italic">
            {{ $t('detailProduitSalon.caracteristique.assistant') }}
          </p>
          <p class="has-text-weight-bold">{{ getAssistantById(produit.assistantId) }}</p>
        </div>
        <div
          class="column is-2">
          <p class="has-text-default is-italic">
            {{ $t('detailProduitSalon.caracteristique.typeProduit') }}
          </p>
          <p class="has-text-weight-bold">{{ getTypeProduitById(sousProduit.typeProduitId) }}</p>
        </div>
        <div class="column is-2" v-if="produit.produitPresse">
          <p class="has-text-default is-italic">
            {{ $t('detailProduitPresse.modeDistribution') }}
          </p>
          <p class="has-text-weight-bold">
            {{ getModeDistribution(produit.produitPresse.modeDistributionId) }}
          </p>
        </div>
        <div class="column is-2" v-if="produit.produitPresse">
          <p class="has-text-default is-italic">
            {{ $t('detailProduitPresse.nbrTirage') }}
          </p>
          <p class="has-text-weight-bold">
            {{ produit.produitPresse.nbTirage }}
          </p>
        </div>
        <div class="column is-2" v-if="produit.produitPresse">
          <p class="has-text-default is-italic">
            {{ $t('detailProduitPresse.controleDisponibilite') }}
          </p>
          <p class="has-text-weight-bold">
            {{ $t(`general.${produit.controleDisponibilite ? 'oui' : 'non'}`) }}
          </p>
        </div>
        <div class="column is-4" v-if="ligneCommandeARenouvelerSpe">
          <p class="has-text-default is-italic">
            {{ $t('detailProduitPresse.renouvelable')}}
          </p>
          <p class="has-text-weight-semibold">
            {{ produit.renouvelable ? $t('general.oui') : $t('general.non') }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import { createNamespacedHelpers } from 'vuex';
import MixinParametreInterne from '@/mixins/parametreInterne';

const Parametres = createNamespacedHelpers('parametres');
const Societe = createNamespacedHelpers('societe');

export default {
  mixins: [MixinParametreInterne],
  name: 'CatalogueProduitGeneralPresseDetailCaracteristique',
  props: {
    produit: {
      type: Object,
      required: false,
    },
    sousProduit: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    ...Societe.mapGetters({
      societeActive: 'societeActive',
      agencesSelectionnees: 'agenceActive',
    }),
    afficherAgence() {
      return this.societeActive.agences.length > 1;
    },
    modeDistribution() {
      return this.parametre(typesParametres.PARAMETRES_KEYS.modeDistribution);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
      loadParametreUtilisateur: 'loadParametreUtilisateur',
    }),
    getModeDistribution(id) {
      const modedistribution = this.modeDistribution.find((mode) => {
        return mode.id === id;
      });
      return modedistribution ? modedistribution.libelle : '';
    },
    getAgenceLibelle(agenceId) {
      const agence = this.agencesSelectionnees.find((agence) => {
        return agence.agenceId === agenceId;
      });
      return agence ? agence.libelleAgence : '';
    },
    getTypeProduitById(typeProduitId) {
      const typeProduit = this.parametre(typesParametres.PARAMETRES_KEYS.typeProduit).find((el) => {
        return el.id === typeProduitId;
      });
      if (typeProduit) return typeProduit.libelle;
      return '';
    },
    getAssistantById(assistantId) {
      const user = this.parametre(typesParametres.PARAMETRES_KEYS.utilisateur).find((user) => {
        return user.id === assistantId;
      });
      if (user) return user.decorator.nomPrenom;
      return '';
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametreUtilisateur();
      await this.loadParametres([typesParametres.PARAMETRES_KEYS.typeProduit,
        typesParametres.PARAMETRES_KEYS.modeDistribution]);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
